import { all, put, takeLatest, call, select } from 'redux-saga/effects'
import * as actionTypes from './action-types'
import * as actionTypesError from '../errors/action-types'
import { fetchNotifications, removeAll, readAll, remove, mark } from './api'
import { orderByDate, countUnread } from './business'
import { getUnreadNotifications, getNotifications } from './selectors'
import { showSnackbar } from '../snackbar/actions'
import arrayToObjectByKeyObject from 'utils/arrayToObjectByKeyObject'

function* notificationsSaga() {
  try {
    const notifications = yield call(fetchNotifications)
    const orderedNotifications = yield call(
      orderByDate,
      notifications._embedded,
    )
    const notificationsEntities = yield call(
      arrayToObjectByKeyObject,
      orderedNotifications,
    )
    yield put({ type: actionTypes.SUCCESS })
    yield put({
      type: actionTypes.SET_DATA,
      payload: notificationsEntities,
    })
    const unread = yield call(countUnread, notifications._embedded)
    yield put({
      type: actionTypes.SET_COUNT,
      payload: unread,
    })
  } catch (e) {
    yield put({ type: actionTypes.ERROR })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

function* removeAllSaga() {
  try {
    yield call(removeAll)
    yield put({ type: actionTypes.REMOVE_ALL_SUCCESS })
    yield put({ type: actionTypes.FETCH })
  } catch (e) {
    yield put({ type: actionTypes.REMOVE_ALL_ERROR })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

function* removeSaga({ payload: { id } }) {
  try {
    yield call(remove, id)
    yield put(showSnackbar({ message: 'notifications:remove-confirm' }))
    yield put({ type: actionTypes.REMOVE_SUCCESS })
    yield put({ type: actionTypes.FETCH })
  } catch (e) {
    yield put({ type: actionTypes.REMOVE_ERROR })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

function* readAllSaga() {
  try {
    yield call(readAll)
    yield put({ type: actionTypes.READ_ALL_SUCCESS })
    yield put({ type: actionTypes.FETCH })
  } catch (e) {
    yield put({ type: actionTypes.READ_ALL_ERROR })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

function* markSaga({ payload: { id, viewed } }) {
  try {
    const notification = yield call(mark, id, viewed)
    yield put({ type: actionTypes.MARK_SUCCESS })
    yield put(
      showSnackbar({
        message: `notifications:${viewed ? 'readed' : 'no-readed'}-confirm`,
      }),
    )
    yield put({
      type: actionTypes.UPDATE_DATA,
      payload: { id, data: notification },
    })
    const totalUnread = yield select(getUnreadNotifications)
    yield put({
      type: actionTypes.SET_COUNT,
      payload: viewed ? totalUnread - 1 : totalUnread + 1,
    })
  } catch (e) {
    yield put({ type: actionTypes.MARK_ERROR })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

function* fakeReadAllSaga() {
  const notifications = yield select(getNotifications)
  const readedNotifications = notifications.map(notification => ({
    ...notification,
    viewed: true,
  }))
  const notificationsEntities = yield call(
    arrayToObjectByKeyObject,
    readedNotifications,
  )
  yield put({
    type: actionTypes.SET_DATA,
    payload: notificationsEntities,
  })
}

export default function* rootSaga() {
  yield all([
    takeLatest(actionTypes.FETCH, notificationsSaga),
    takeLatest(actionTypes.REMOVE_ALL, removeAllSaga),
    takeLatest(actionTypes.REMOVE, removeSaga),
    takeLatest(actionTypes.READ_ALL, readAllSaga),
    takeLatest(actionTypes.MARK, markSaga),
    takeLatest(actionTypes.FAKE_READ_ALL, fakeReadAllSaga),
  ])
}
